import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { ColorRing } from "react-loader-spinner";
import { getPaymentPercentage } from "../../../../utils/apis/booking/booking";
const Wallet_Payment_modal = (props) => {
  const { register, handleSubmit, watch } = useForm();

  const [selectedPercent, setSelectedPercent] = useState(null);
  const [percentValue, setPercentValue] = useState(0);
  const [percentData, setPercentData] = useState([]);

  const handleRadioChange = (item) => {
    console.log("handleRadioChange", item);
    setSelectedPercent(item);
  };

  const paymentPercentApi = async () => {
    try {
      const res = await getPaymentPercentage();

      if (res?.success) {
        setPercentData(res?.data);
        setSelectedPercent(res?.data?.[0]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    paymentPercentApi();
  }, []);

  useEffect(() => {
    const percentAmount = (
      (props?.total * selectedPercent?.name) /
      100
    ).toFixed(2);

    setPercentValue(percentAmount);

    props?.set_advance_amount(Number(percentAmount));
    props?.set_payment_percentage_id(Number(selectedPercent?.id));
  }, [selectedPercent]);

  console.log("props?.total", props?.total);

  // Watching for selected payment type
  const selectedPaymentType = watch("payment_type");

  const selectedPercentValue = watch("percent_amount");

  // Automatically update the parent with the selected payment type
  useEffect(() => {
    if (props.setPaymentType) {
      props.setPaymentType(selectedPaymentType);
    }
  }, [selectedPaymentType, props]);

  const onSubmit = (data) => {
    const newData = {
      ...data,
    };

    console.log("newData", newData);

    if (props.handleSubmit) {
      props.handleSubmit(newData);
    }
  };

  const percent = [25, 50, 75, 100];

  console.log("selectedPaymentType", selectedPaymentType);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="booking-cancel-modal Wallet_Payment_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <h4 className="title">Booking Payment</h4>
          </div>

          <div className="reasons-div">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3 text-center">
                <Form.Check
                  inline
                  label="Online"
                  name="payment_type"
                  type="radio"
                  value="online"
                  id="inline-radio-2"
                  defaultChecked
                  {...register("payment_type", { required: true })}
                />

                {props?.userdataAmount >= props?.total ? (
                  <Form.Check
                    inline
                    label="Wallet"
                    name="payment_type"
                    type="radio"
                    value="wallet"
                    id="inline-radio-1"
                    {...register("payment_type", { required: true })}
                  />
                ) : null}
              </div>

              {selectedPaymentType === "online" ? (
                <div className="payment_percent_div">
                  <div className="percent_card_heading">
                    <p>Percentage</p>
                  </div>
                  <div className="row d-flex justify-content-center">
                    {percentData?.length > 0 &&
                      percentData?.map((item) => {
                        const isChecked = selectedPercent?.id === item?.id;

                        console.log("isChecked", isChecked, selectedPercent);

                        return (
                          <div className="col-lg-3">
                            <div
                              className={`payement_percent_card ${
                                isChecked ? "selected-card" : ""
                              }`}
                            >
                              <div className="">
                                <Form.Check
                                  inline
                                  label={item?.name}
                                  name="percent_amount"
                                  type="radio"
                                  value={item?.name}
                                  checked={isChecked}
                                  id={`inline-radio-${item?.name}`}
                                  onChange={() => handleRadioChange(item)}
                                />
                              </div>

                              <div className="percent_amount_holder">
                                <p className="amount">
                                  {(
                                    (props?.total * Number(item?.name)) /
                                    100
                                  ).toFixed(2)}
                                </p>
                                <p className="percent">{Number(item?.name)}%</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              ) : null}

              {selectedPaymentType === "wallet" ? (
                <div className="payment_percent_div">
                  <div className="percent_card_heading">
                    <p>Percentage</p>
                  </div>
                  <div className="row d-flex justify-content-center">
                    {percentData?.length > 0 &&
                      percentData?.map((item) => {
                        const isChecked = selectedPercent?.id === item?.id;

                        console.log("isChecked", isChecked, selectedPercent);

                        return (
                          <div className="col-lg-3">
                            <div
                              className={`payement_percent_card ${
                                isChecked ? "selected-card" : ""
                              }`}
                            >
                              <div className="">
                                <Form.Check
                                  inline
                                  label={item?.name}
                                  name="percent_amount"
                                  type="radio"
                                  value={item?.name}
                                  checked={isChecked}
                                  id={`inline-radio-${item?.name}`}
                                  onChange={() => handleRadioChange(item)}
                                />
                              </div>

                              <div className="percent_amount_holder">
                                <p className="amount">
                                  {(
                                    (props?.total * Number(item?.name)) /
                                    100
                                  ).toFixed(2)}
                                </p>
                                <p className="percent">{Number(item?.name)}%</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              ) : null}

              {props.loading ? (
                <div className="d-flex justify-content-center mt-5">
                  <ColorRing
                    className="blocks-wrapper"
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="blocks-loading"
                    wrapperStyle={{}}
                    wrapperClass="blocks-wrapper"
                    colors={[
                      "#e15b64",
                      "#f47e60",
                      "#f8b26a",
                      "#abbd81",
                      "#849b87",
                    ]}
                  />
                </div>
              ) : (
                <div className="d-flex justify-content-center mt-5">
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={props.onHide}
                  >
                    CANCEL
                  </button>
                  <button type="submit" className="submit-btn">
                    SUBMIT
                  </button>
                </div>
              )}

              {/* <div className="d-flex justify-content-center mt-5">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={props.onHide}
                >
                  CANCEL
                </button>
                <button type="submit" className="submit-btn">
                  SUBMIT
                </button>
              </div> */}
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Wallet_Payment_modal;
